import { useQuery, UseQueryResult } from "@tanstack/react-query"
import { ChatWidget } from "@/lib/types"
import { apiClient } from "../lib/api/api-client"

export default function useWidgetConfig(): UseQueryResult<ChatWidget> {
  return useQuery({
    queryKey: ['chat_widget'],
    queryFn: () => apiClient.get(`/widget`),
  })
}
